import _ from 'lodash';
import * as DialogActions from 'app/dialog/features/dialog.actions';
import { Component, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MdbSelectModule } from 'mdb-angular-ui-kit/select';
import { CoreModule } from 'app/core/core.module';
import { MdbAutocompleteModule } from 'mdb-angular-ui-kit/autocomplete';
import { CommonModule } from '@angular/common';
import { GoogleMapsAutocompleteModule } from 'app/google-maps-autocomplete/google-maps-autocomplete.module';
import { NgxCurrencyDirective } from 'ngx-currency';
import { Subject } from 'rxjs';
import { MdbPopoverDirective, MdbPopoverModule } from 'mdb-angular-ui-kit/popover';
import { PopoverService } from 'app/core/services/popover.service';
import { Store } from '@ngrx/store';

let id = 1;
@Component({
  standalone:true,
  selector: 'app-user-action-cell',
  templateUrl: './user-action-cell.component.html',
  styleUrls: ['./user-action-cell.component.scss'],
  imports:[FormsModule,ReactiveFormsModule,MdbSelectModule,CoreModule,CommonModule,MdbPopoverModule,MdbAutocompleteModule,GoogleMapsAutocompleteModule, NgxCurrencyDirective]
})
export class UserActionCellComponent implements OnInit {
    @ViewChild('popover') popover: MdbPopoverDirective = null;
    
    @Output()
    public emitter = new Subject<any>();
  
    @Input()
    public data: any = {};

    @Input()
    public readonly: boolean = false;

    private _id = id++;
    get id() {
      return `UserActionCellPopover_${this._id}`;
    }
    
    private takeUntilSubject: Subject<any> = new Subject();

    constructor(
        private store: Store,
        private popoverService: PopoverService,
    ) { }

    ngOnInit(): void {
    }

    onPopoverShown(): void {
        this.popoverService.list[this.id] = this.popover;
    }

    onPopoverHidden(): void {
        delete this.popoverService.list[this.id];
    }

    onConfirmAction(header, text, callback) {
        const action = DialogActions.openDialog({
          payload: {
            name: "confirmComponent",
            options: {
              size: 'small',
              modalClass:'modal--paybee modal-sm',
              containerClass:'mdb-modal-backdrop-paybee'
            },
            initialState: {
              header, text,
              buttonCancel: "No",
              buttonConfirm: "Yes",
              callback: (value) => {
                if(value) {
                  callback();
                }
              }
            }
          }
        });
        this.store.dispatch(action);
    }

    editAccount() {
        if(this.readonly) {
            return;
        }

        this.emitter.next({
            cmd: "edit",
            data: this.data,
        });
    }

    deleteUser() {
        if(this.readonly) {
            return;
        }

        this.onConfirmAction(`Are you sure?`, `You want to delete this account.`, () => {
            this.emitter.next({
                cmd: "delete",
                data: this.data,
            });
        });
    }

    resetPassword() {
        if(this.readonly) {
            return;
        }
        
        this.onConfirmAction(`Are you sure?`, `You want to reset password for this account.`, () => {
            this.emitter.next({
                cmd: "reset-password",
                data: this.data,
            });
        });
    }

    ngAfterViewInit(): void {
    }

    ngOnDestroy() {
        this.takeUntilSubject.next(null);
        this.takeUntilSubject.complete();
    }

    getAccountStatusString(status) {
        switch(status) {
            case 1: return "Live"
            case 2: return "Pending"
            case 3: return "Deleted"
            default: return "unknown"
        }
      }
}
